export interface SaleVetModel {
  checkbox: any;
  memberId: any;
  firstName: string;
  lastName: string;
  clinic: string;
  userId: any;
  email: string;
  mobile: string;
  lotsViewed: any;
  inDraft: any;
  inReview: any;
  denied: any;
  approved: any;
}

export enum SaleVetTableFields {
  FIRST_NAME = 'firstName',
  LAST_NAME = 'lastName',
  CLINIC = 'clinic',
  EMAIL = 'email',
  MOBILE = 'mobile',
  LOTS_VIEWED = 'lotsViewed',
  DRAFT = 'inDraft',
  IN_REVIEW = 'inReview',
  DENIED = 'denied',
  APPROVED = 'approved'
}

export class SaleVetSearchFields {
  firstName: string;
  lastName: string;
  clinic: string;
  email: string;
  mobile: string;
}
